import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import { TableList, newColumnDateByLocale, newColumnText, newColumnValueWithNumberComponent } from "../../TableList";
import { useTableOptions } from "../../../../util/tableOptionsMaterialTable";

const useStyles = makeStyles((theme) => ({
  title: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2),
  },
}));

const ContractsWithEarningsByYear = ({ currentUser, user, data = [], year }) => {
  const classes = useStyles();
  const options = useTableOptions({ toolbar: false });
  const columns = React.useMemo(
    () => [
      newColumnText("app.id", "id", (row) => `C ${row.id}`),
      newColumnDateByLocale("app.createdAt", "createdAt"),
      newColumnDateByLocale("app.dueDate", "dueDate"),
      newColumnValueWithNumberComponent("app.value", "amount", user.taxResidence, currentUser.hideValues),
      newColumnValueWithNumberComponent("app.yield", "earnings", user.taxResidence, currentUser.hideValues, true),
    ],
    [currentUser.hideValues, user.taxResidence],
  );

  return (
    <>
      <Typography
        gutterBottom
        variant="h6"
        color="primary"
        className={classes.title}
      >
        <FormattedMessage id="app.earnings.contractsHistory" />
      </Typography>

      <Typography
        variant="body2"
        gutterBottom
      >
        <FormattedHTMLMessage
          id="app.earnings.aboutContracts"
          values={{ year }}
        />
      </Typography>

      <TableList
        data={data}
        columns={columns}
        options={options}
        country={currentUser.taxResidence}
        user={currentUser}
      />
    </>
  );
};

export default ContractsWithEarningsByYear;
